import React from 'react';
import classnames from 'classnames';
import ArtStageArrowL from '@wix/da-ds/pkg/Icons/ArtStageArrowL';
import ArtStageArrowR from '@wix/da-ds/pkg/Icons/ArtStageArrowR';
import { DuperbrowseNavigationItem } from '../redux/types';
import BackToStreamButton from '../BackToStreamButton';
import { DuperbrowsePaddle } from './DuperbrowsePaddle';
import { useDuperbrowseKeyboardNavigation } from '../hooks/useDuperbrowseKeyboardNavigation';

import s from './DuperbrowsePaddles.scss';

export interface Props {
  isInZoomModal?: boolean;
  enableKeyboardNavigation: boolean;
  className?: string;
  paddleClassName?: string;
  iconClassName?: string;
  backToStreamButtonClassName?: string;
  navigation: DuperbrowseNavigationItem;
  showBackTo?: boolean;
  preloadEnabled?: boolean;
  isDuperbrowseActive?: boolean;

  moveNext: () => void;
  movePrev: () => void;
}

const DuperbrowsePaddles: React.FC<React.PropsWithChildren<Props>> = ({
  className,
  paddleClassName,
  iconClassName,
  backToStreamButtonClassName,
  enableKeyboardNavigation,
  navigation: { nextItem, prevItem },
  showBackTo = true,
  moveNext,
  movePrev,
}) => {
  useDuperbrowseKeyboardNavigation(enableKeyboardNavigation);

  return (
    <div className={classnames(s['root'], className)}>
      <DuperbrowsePaddle
        isEnabled={!!prevItem}
        className={classnames(s['prev'], paddleClassName)}
        onClick={movePrev}
        dataHook="arrowL"
      >
        <ArtStageArrowL
          customSizable
          disableDefaultColors
          className={classnames(s['icon'], iconClassName)}
        />
      </DuperbrowsePaddle>
      {showBackTo && <BackToStreamButton className={backToStreamButtonClassName} />}
      <DuperbrowsePaddle
        isEnabled={!!nextItem}
        className={classnames(s['next'], paddleClassName)}
        onClick={moveNext}
        dataHook="arrowR"
      >
        <ArtStageArrowR
          customSizable
          disableDefaultColors
          className={classnames(s['icon'], iconClassName)}
        />
      </DuperbrowsePaddle>
    </div>
  );
};

export default DuperbrowsePaddles;
